import React, { useContext } from 'react';
import { FetchResult, MutationResult } from '@apollo/client';
import {
    RemoveStructuredBriefDesignersComponent,
    RemoveStructuredBriefDesignersMutation,
    RemoveStructuredBriefDesignersMutationVariables,
} from '@99designs/apps/spa/pages/create/mutations/RemoveStructuredBriefDesigners.generated';
import { BriefContext } from '@99designs/brief';
import { DesignerSource } from '@99designs/graph-utils/types';

interface Props {
    children: (
        removeStructuredBriefDesigners: (
            variables: RemoveStructuredBriefDesignersMutationVariables
        ) => Promise<void | FetchResult<RemoveStructuredBriefDesignersMutation>>,
        result: MutationResult
    ) => React.ReactElement;
}

const RemoveStructuredBriefDesigners = ({ children }: Props) => {
    const { brief } = useContext(BriefContext);

    return (
        <RemoveStructuredBriefDesignersComponent>
            {(mutation, result) => {
                return children((variables) => {
                    const dws = brief.designers.map((d, i) => ({
                        ...d,
                        source: brief.designersWithSource[i].source,
                    }));

                    const variablesDesignerIds =
                        typeof variables.designerIds === 'number'
                            ? [variables.designerIds]
                            : variables.designerIds;

                    return mutation({
                        variables,
                        optimisticResponse: dws
                            ? ({
                                  removeStructuredBriefDesigners: {
                                      id: variables.id,
                                      __typename: 'StructuredBrief',
                                      designers: dws
                                          .filter(
                                              (d) =>
                                                  variablesDesignerIds.indexOf(parseInt(d.id)) < 0
                                          )
                                          .map((d) => ({
                                              id: d.id,
                                              __typename: 'User',
                                          })),
                                      designersWithSource: dws
                                          .slice()
                                          .filter(
                                              (d) =>
                                                  variablesDesignerIds.indexOf(parseInt(d.id)) < 0
                                          )
                                          .map((d) => ({
                                              __typename: 'DesignerWithSource',
                                              source: d.source as DesignerSource,
                                          })),
                                  },
                              } as RemoveStructuredBriefDesignersMutation)
                            : undefined,
                    });
                }, result);
            }}
        </RemoveStructuredBriefDesignersComponent>
    );
};

export default RemoveStructuredBriefDesigners;
